import { Mutation } from '@varo/graphql-schema-types';
import SetCardLocked from 'services/graphql/mutations/SetCardLocked';
import { useFormattedGQLErrors } from 'shared/hooks/errorFormatters/useFormattedGQLErrors';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

export const useFreezeCard = () => {
  const [{ fetching, error, data }, executeLockCardMutation] =
    useCancellableMutation<Mutation>(SetCardLocked);

  const formattedError = useFormattedGQLErrors({
    combinedError: error,
    errorLike: data?.setCardLocked,
  });

  return {
    setFrozenState: (cardId: string, toFrozen: boolean) => {
      // note: gql mutation requires idempotencyId but it is unused in the backend
      return executeLockCardMutation({
        idempotencyId: 'unused',
        cardId,
        locked: toFrozen,
      }).catch(() => {
        // swallow error here since it's always an abort error
      });
    },
    fetching,
    error: formattedError,
    data,
  };
};
